import {
  SET_USER_CURR,
  CHECK_PHP_CONNECTION_STATUS,
  SET_DARK_MODE,
  GET_CSRF_TOKEN,
  GET_USER_SETTINGS,
  SET_HEADER_DARK,
  STORE_CSRF_COOKIE,
  STORE_NEW_TOKEN,
  SAVE_BROWSER_LANG,
  SET_GLOBAL_SEARCH,
  GET_FAV_MARKETS_IDS,
  SET_HIGH_CHARTS_RANGE,
  SAVE_FAV_MARKETS,
  DELETE_FAV_MARKETS,
  GET_AUTH_IDS,
  GET_AUTH_EXCH_IDS,
  GET_USER_BALANCES,
  GET_BALANCE_HISTORY,
  GET_USER_OPEN_ORDERS,
  GET_ORDER_TYPES,
  GET_ORDER_STATUS_TYPES,
  GET_ORDERS_HISTORY,
  GET_OHLC_PRICES,
  SET_TABLE_ROWS,
  GET_USER_PREFS,
  PLACE_ORDER,
  CHECK_USER_APPLICATIONS,
} from '../actions/userActions'
import SearchItemModel from '../../models/SearchItemModel'
import SearchMarketModel from '../../models/SearchMarketModel'
import BalanceModel from '../../models/BalanceModel'
import OrderModel from '../../models/OrderModel'

export interface UserState {
  exchRate: number
  currSign: string
  selectedCurr: string
  session_expired: boolean
  darkMode: boolean
  csrf_token: string | false
  user_settings: any
  favMarketIds: any[]
  headerDark: boolean
  csrfCookie: string
  newToken: string
  browserLang: string
  searchResultExchs: SearchItemModel[]
  searchResultMkts: SearchMarketModel[]
  searchResultCurrs: SearchItemModel[]
  highChartsRange: number | null
  authIds: any[]
  authExchIds: number[]
  balances: BalanceModel[]
  openOrders: OrderModel[]
  orderTypes: any[]
  orderStatusTypes: any[]
  ordersHistory: OrderModel[]
  balHistory: Array<[number, number]>
  ohlcPrices: number[]
  tableRows: number
  userPrefs: any | false
  orderResponse: any | false
  user_applications: any[]
  favMarkets?: any[]
}

interface UserAction {
  type: string
  exchRate?: number
  currSign?: string
  selectedCurr?: string
  session_expired?: boolean
  darkMode?: boolean
  csrf_token?: string
  user_settings?: any
  favMarketIds?: any[]
  headerDark?: boolean
  csrfCookie?: string
  newToken?: string
  browserLang?: string
  searchResultExchs?: SearchItemModel[]
  searchResultMkts?: SearchMarketModel[]
  searchResultCurrs?: SearchItemModel[]
  highChartsRange?: number | null
  authIds?: any[]
  authExchIds?: number[]
  balances?: BalanceModel[]
  openOrders?: OrderModel[]
  orderTypes?: any[]
  orderStatusTypes?: any[]
  ordersHistory?: OrderModel[]
  balHistory?: Array<[number, number]>
  ohlcPrices?: number[]
  tableRows?: number
  userPrefs?: any
  orderResponse?: any
  user_applications?: any[]
  favMarkets?: any[]
}

const initialState: UserState = {
  exchRate: 1,
  currSign: '$',
  selectedCurr: 'USD',
  // setting session_expired = true temporarily
  session_expired: true,
  darkMode: false,
  csrf_token: false,
  user_settings: {},
  favMarketIds: [],
  headerDark: true,
  csrfCookie: '',
  newToken: '',
  browserLang: '',
  searchResultExchs: [],
  searchResultMkts: [],
  searchResultCurrs: [],
  // searchResultNews: [],
  highChartsRange: null,
  authIds: [],
  authExchIds: [],
  balances: [],
  openOrders: [],
  orderTypes: [],
  orderStatusTypes: [],
  ordersHistory: [],
  balHistory: [],
  ohlcPrices: [],
  tableRows: 50,
  userPrefs: false,
  orderResponse: false,
  user_applications: [],
}

const userReducer = (state: UserState = initialState, action: UserAction): UserState => {
  switch (action.type) {
    case SET_USER_CURR:
      return {
        ...state,
        exchRate: action.exchRate || state.exchRate,
        currSign: action.currSign || state.currSign,
        selectedCurr: action.selectedCurr || state.selectedCurr,
      }
    case CHECK_PHP_CONNECTION_STATUS:
      return {
        ...state,
        session_expired: action.session_expired !== undefined ? action.session_expired : state.session_expired,
      }
    case SET_DARK_MODE:
      return {
        ...state,
        darkMode: action.darkMode !== undefined ? action.darkMode : state.darkMode,
      }
    case SAVE_BROWSER_LANG:
      return {
        ...state,
        browserLang: action.browserLang || state.browserLang,
      }
    case SET_HEADER_DARK:
      return {
        ...state,
        headerDark: action.headerDark !== undefined ? action.headerDark : state.headerDark,
      }
    case GET_CSRF_TOKEN:
      return {
        ...state,
        csrf_token: action.csrf_token || state.csrf_token,
      }
    case STORE_CSRF_COOKIE:
      return {
        ...state,
        csrfCookie: action.csrfCookie || state.csrfCookie,
      }
    case STORE_NEW_TOKEN:
      return {
        ...state,
        newToken: action.newToken || state.newToken,
      }
    case GET_USER_SETTINGS:
      return {
        ...state,
        user_settings: action.user_settings || state.user_settings,
      }
    case GET_FAV_MARKETS_IDS:
      return {
        ...state,
        favMarketIds: action.favMarketIds || state.favMarketIds,
      }
    case SAVE_FAV_MARKETS:
      return {
        ...state,
        favMarkets: action.favMarkets || state.favMarkets,
      }
    case DELETE_FAV_MARKETS:
      return {
        ...state,
        favMarkets: action.favMarkets || state.favMarkets,
      }
    case SET_GLOBAL_SEARCH:
      return {
        ...state,
        searchResultExchs: action.searchResultExchs || state.searchResultExchs,
        searchResultMkts: action.searchResultMkts || state.searchResultMkts,
        searchResultCurrs: action.searchResultCurrs || state.searchResultCurrs,
        // searchResultNews: action.searchResultNews,
      }
    case SET_HIGH_CHARTS_RANGE:
      return {
        ...state,
        highChartsRange: action.highChartsRange !== undefined ? action.highChartsRange : state.highChartsRange,
      }
    case SET_TABLE_ROWS:
      return {
        ...state,
        tableRows: action.tableRows || state.tableRows,
      }
    case GET_AUTH_IDS:
      return {
        ...state,
        authIds: action.authIds || state.authIds,
      }
    case GET_AUTH_EXCH_IDS:
      return {
        ...state,
        authExchIds: action.authExchIds || state.authExchIds,
      }
    case GET_USER_BALANCES:
      return {
        ...state,
        balances: action.balances || state.balances,
      }
    case GET_BALANCE_HISTORY:
      return {
        ...state,
        balHistory: action.balHistory || state.balHistory,
      }
    case GET_OHLC_PRICES:
      return {
        ...state,
        ohlcPrices: action.ohlcPrices || state.ohlcPrices,
      }
    case GET_USER_OPEN_ORDERS:
      return {
        ...state,
        openOrders: action.openOrders || state.openOrders,
      }
    case GET_ORDER_TYPES:
      return {
        ...state,
        orderTypes: action.orderTypes || state.orderTypes,
      }
    case GET_ORDER_STATUS_TYPES:
      return {
        ...state,
        orderStatusTypes: action.orderStatusTypes || state.orderStatusTypes,
      }
    case GET_ORDERS_HISTORY:
      return {
        ...state,
        ordersHistory: action.ordersHistory || state.ordersHistory,
      }
    case GET_USER_PREFS:
      return {
        ...state,
        userPrefs: action.userPrefs !== undefined ? action.userPrefs : state.userPrefs,
      }
    case PLACE_ORDER:
      return {
        ...state,
        orderResponse: action.orderResponse !== undefined ? action.orderResponse : state.orderResponse,
      }
    case CHECK_USER_APPLICATIONS:
      return {
        ...state,
        user_applications: action.user_applications || state.user_applications,
      }
    default:
      return state
  }
}

export default userReducer 